import { Route } from '@angular/router';
import { isAgentGuard } from '@rma/authentication/public/util-auth-redirect';
import { featureFlagGuard } from '@rma/common-ui-ng/feature-flags';
import { TempFeatureFlags } from '@rma/generic/util/feature-flags';

export const settingsRoutes: Route[] = [
  {
    path: 'settings',
    children: [
      {
        path: 'data-feeds',
        loadChildren: () => import('@rma/settings/data-feed-management'),
      },
      {
        path: 'easy-reviews',
        loadChildren: () => import('@rma/settings/easy-reviews'),
      },
      {
        path: 'email-preferences',
        loadChildren: () => import('@rma/settings/email-preferences'),
      },
      {
        path: 'linked-accounts',
        loadChildren: () => import('@rma/linked-accounts/settings'),
      },
      {
        path: 'templates',
        loadChildren: () => import('@rma/communication/message-templates'),
      },
      {
        path: 'review-links',
        loadChildren: () => import('@rma/settings/review-links'),
      },
      {
        path: 'assistants',
        loadChildren: () => import('@rma/assistant-access/access-approval'),
        canActivate: [isAgentGuard('/manage-account/assistant-access')],
      },
      {
        path: 'brand-kits',
        loadChildren: () => import('@rma/settings/brand-kits'),
        canActivate: [featureFlagGuard(TempFeatureFlags.BrandKitAdmin, false)],
      },
    ],
  },
];
